import React, { createContext, useContext, useState, ReactNode } from "react";

interface BookAppointmentContextType {
  isBookAppointmentModalOpen: boolean;
  openBookAppointmentModal: () => void;
  closeBookAppointmentModal: () => void;
}

const BookAppointmentContext = createContext<BookAppointmentContextType | undefined>(undefined);

export const BookAppointmentProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isBookAppointmentModalOpen, setIsBookAppointmentModalOpen] = useState(false);

  const openBookAppointmentModal  = () => setIsBookAppointmentModalOpen(true);
  const closeBookAppointmentModal = () => setIsBookAppointmentModalOpen(false);

  return (
    <BookAppointmentContext.Provider
      value={{ isBookAppointmentModalOpen, openBookAppointmentModal, closeBookAppointmentModal }}
    >
      {children}
    </BookAppointmentContext.Provider>
  );
};

export const useBookAppointment = () => {
  const ctx = useContext(BookAppointmentContext);
  if (!ctx) throw new Error("useBookAppointment must be used within BookAppointmentProvider");
  return ctx;
};